const FormatIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		{...props}
	>
		<path d="M2 2H10M6 8H13M6 11H11M6 5H12" stroke="currentColor" strokeWidth="2"/>
		<path d="M2 5L5 7.5L2 10V5Z" fill="currentColor"/>
	</svg>
)

export default FormatIcon